/*
* 阔地教育科技有限公司版权所有（codyy.com/codyy.cn）.
* Copyright (c) 2019, Codyy and/or its affiliates. All rights reserved.
* @Date: 2020.01.01 12:48.
* @Author
* @Description axios 请求封装
**/

import axios from 'axios'
import Qs from 'qs'
import * as status from './status' // 接口返回状态值
import { MessageBox } from 'element-ui'

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

const service = axios.create({
  baseURL: 'http://web.zgjyfzb.com', // api 的 base_url  最好采用 Ng inx 或 dev-server代理，这里可以不填
  timeout: 60 * 1000 // 请求超时时间
})

/**
 * 请求发送 --- 有token时 要添加token
 */
service.interceptors.request.use(
  config => {
    // if (getToken()) {
    //   config.headers.Authorization = 'Bearer ' + getToken()
    // }
    if(config.method==="post")
    {
      config.data=Qs.stringify(config.data)
      config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    }
    console.log('request.js**config**', config)
    return config
  },
  error => {
    console.log('request.js----error---', error) // for debug
    Promise.reject(error)
  }
)

/**
 * 请求响应
 */
service.interceptors.response.use(
  response => {
   console.log("midatong***",response) 
    const res =  response.data
    if (res.status === status.ERROR) {
      MessageBox.confirm( res.message, '提示',{
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
      return Promise.reject(new Error('logout'))
    } else if (res.status !== status.SUCCESS) {
      return Promise.reject(res)
    } else {
      return res.result
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)


export default service
